export const SAVE_OPTIONS = [
  {
    id: 'savequery',
    automationId: 'querybuilder-savequery-button',
    label: 'Save Query',
  },
  {
    id: 'saveform',
    automationId: 'querybuilder-saveform-button',
    label: 'Save Form',
  },
];

export const BUTTON_CONFIG = (nodesList) => [
  {
    label: 'Download',
    automationId: 'querybuilder-import-file-button',
    id: 'inbox',
    ally: { name: 'Import', description: 'Import File' },
  },
  {
    label: 'SaveFile',
    automationId: 'querybuilder-save-file-button',
    ally: { name: 'Save Options', description: 'Save Options' },
    dropdown: true,
    id: 'saveFile',
    disabled: !nodesList || nodesList.length === 0,
  },
  {
    label: 'Redo',
    automationId: 'querybuilder-reset-query-button',
    id: 'redo',
    ally: { name: 'Reset Query', description: 'Reset Query' },
    disabled: !nodesList || nodesList.length === 0,
  },
  {
    label: 'Trash',
    automationId: 'querybuilder-delete-query-button',
    id: 'trash',
    ally: { name: 'Delete Query', description: 'Delete Query' },
    disabled: !nodesList || nodesList.length === 0,
  },
];
